import React, { useState } from 'react';
import RegistrationForm from './RegistrationForm.js';
import AuthCard, { AuthLink } from '../auth-shared/AuthCard.js';
import './registration-v2.css';

/**
 * RegistrationPage — mounted at the existing `/authorization/registration/`
 * URL, which the homepage's sign-up entry points now link to.
 *
 * The old page carried a paragraph in a side column explaining what an account
 * is for. It moves into the card's subtitle: a column of prose beside a
 * three-field form was Bootstrap's answer to a wide viewport, not something
 * the reader needed. It also disappears on success, where a pitch for signing
 * up would be talking about something already done.
 */
export default function RegistrationPage() {
	const [succeeded, setSucceeded] = useState(false);

	return (
		<div className="auth-v2">
			<AuthCard
				title={succeeded ? 'Almost there' : 'Create your account'}
				subtitle={
					succeeded
						? undefined
						: 'One account works for joining an organization or starting your own.'
				}
				footer={
					succeeded ? null : (
						<p className="m-0">
							Already have an account? <AuthLink href="/authorization/">Sign in</AuthLink>
						</p>
					)
				}
			>
				<RegistrationForm onSuccess={() => setSucceeded(true)} />
			</AuthCard>
		</div>
	);
}
